import { getDateRange } from 'helpers/utils';

// The date set on a memory, as precise as it was entered: "2023", "May 2023",
// "May 26, 2023", or a range such as "May 2023 - June 2024". Empty when the
// memory has no date set.
export const memoryDateLabel = (
  startDate?: string | null,
  endDate?: string | null,
) => {
  const range = getDateRange(startDate ?? undefined, endDate ?? undefined);
  if (!range.startDate) return '';
  return range.endDate && range.endDate !== range.startDate
    ? `${range.startDate} - ${range.endDate}`
    : range.startDate;
};
